import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
var LoadingService = /** @class */ (function () {
    function LoadingService() {
        this._subject = new Subject();
        this.count = 0;
    }
    LoadingService.prototype.on = function () {
        this.count++;
        if (this.count > 0) {
            this._subject.next(true);
        }
    };
    LoadingService.prototype.off = function () {
        this.count--;
        if (this.count == 0) {
            this._subject.next(false);
        }
    };
    Object.defineProperty(LoadingService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    LoadingService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    LoadingService.ctorParameters = function () { return []; };
    return LoadingService;
}());
export { LoadingService };
//# sourceMappingURL=loading.service.js.map